export function isUrlData(data) {
    return !!data['url'];
}
export function isInlineData(data) {
    return !!data['values'];
}
export function isNamedData(data) {
    return !!data['name'] && !isUrlData(data) && !isInlineData(data);
}
export var MAIN = 'main';
export var RAW = 'raw';
//# sourceMappingURL=data.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/data.js
// module id = 45
// module chunks = 0